//NOTE autogenerated by export script
export {AddressAPIService as Address} from './addressAPI.service'
export {AdminAPIService as Admin} from './adminAPI.service'
export {MailjetMonitoringControllerService as MailjetMonitoring} from './mailjetMonitoringController.service'
export {MessagebirdMonitoringControllerService as MessagebirdMonitoring} from './messagebirdMonitoringController.service'
export {RecipientCountryControllerService as RecipientCountry} from './recipientCountryController.service'
export {RulesAPIService as Rules} from './rulesAPI.service'
export {UnsubscribeAPIService as Unsubscribe} from './unsubscribeAPI.service'
export {BASE_PATH} from '../variables'
export {ApiModule} from '../api.module'
export {AllServices as All} from './allService'